import { useCurrentPage } from './useCurrentPage';
import { useTemplates } from '../contexts/TemplatesContext';
import { TEMPLATES_PER_PAGE } from '../consts';

export const usePagination = () => {
  const currentPage = useCurrentPage();
  const { totalTemplatesCount } = useTemplates();

  return {
    currentPage,
    totalPages: Math.ceil(totalTemplatesCount / TEMPLATES_PER_PAGE),
  };
};
